import { Action, Selector, State, StateContext } from '@ngxs/store';

import { Injectable } from '@angular/core';
import { Login, Logout, SelectBrand } from './auth.actions';
import { AuthStateModel } from './auth-state.model';
import { Currency } from '../../core/models/brand/currency.model';
import { CurrencyService } from '../../core/services/currency/currency.service';
import { tap } from 'rxjs';
import { UserRole } from '../../core/enum/user-role.enum';

@Injectable()
@State<AuthStateModel>({
    name: 'auth',
    defaults: {
        token: null,
        refreshToken: null,
        brand: null,
        selectedBrand: null,
        selectedBrandName: null,
        user: null,
        roles: [],
        currencies: [],
    },
})
export class AuthState {
    constructor(private readonly currencyService: CurrencyService) {}

    @Selector()
    static getSelectedBrand(state: AuthStateModel): any {
        return state.brand || null;
    }

    @Selector()
    static getSelectedBrandName(state: AuthStateModel): any {
        return state.brand.name || null;
    }

    @Selector()
    static getRoles(state: AuthStateModel): UserRole[] {
        return state.roles;
    }

    @Selector()
    static getDefaultCurrency(state: AuthStateModel): Currency | null {
        return (
            state.currencies.find((x) => x.isDefault) ||
            state.currencies[0] ||
            null
        );
    }

    @Selector()
    static getCurrencies(state: AuthStateModel): Currency[] {
        return state.currencies;
    }

    @Action(Login)
    login(ctx: StateContext<AuthStateModel>, { data }: Login): void {
        ctx.patchState({
            token: data.token,
            refreshToken: data.refreshToken,
            user: data.user,
            roles: data.user.roles,
        });
    }

    @Action(Logout)
    logout(ctx: StateContext<AuthStateModel>): void {
        ctx.patchState({
            token: null,
            refreshToken: null,
            user: null,
            roles: [],
            currencies: [],
        });
    }

    @Action(SelectBrand)
    selectBrand(ctx: StateContext<AuthStateModel>, { brand }: SelectBrand) {
        ctx.patchState({ brand });

        if (!brand.id) {
            return;
        }
        return this.currencyService.getCurrencies().pipe(
            tap((res) => {
                ctx.patchState({ currencies: res });
            }),
        );
    }
}
